import React, { useState } from "react";
import PropTypes from "prop-types";
import useFetchApi from "hooks/useFetchApi";
import { mutateSimulation } from "hooks/useSimulation";
import StatusTimeline from "components/Status/StatusTimeline";

const statusList = [
  { id: 1, label: "Nouveau" },
  { id: 2, label: "Contacté" },
  { id: 3, label: "Demande de transformation" },
  { id: 4, label: "Converti" },
  { id: 5, label: "Abandon" },
];

const StatusClient = ({ status, role, id }) => {
  const [error, setError] = useState("");
  const [fetchApi] = useFetchApi();

  const updateStatus = async (id, newStatus) => {
    await fetchApi(`simulations/${id}`, {
      method: "PUT",
      body: {
        data: {
          statut: newStatus,
        },
      },
    });
    mutateSimulation(id);
  };

  return (
    <StatusTimeline
      id={id}
      role={role}
      statusList={statusList}
      status={status}
      updateStatus={updateStatus}
      error={error}
      setError={setError}
    />
  );
};
StatusClient.propTypes = {
  status: PropTypes.string,
  role: PropTypes.string,
  id: PropTypes.string,
};

export default StatusClient;
